/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

window.addEventListener('DOMContentLoaded', function () {
	let productData;

	function updateProductData() {
		const scriptTag = document.querySelector('script[data-product-json]');
		if (scriptTag) {
			const productJson = scriptTag.innerText;
			productData = JSON.parse(productJson);
		}
	}
	updateProductData();

	const productBox = document.querySelector('.Product__Info .Container');
	const firstSection = document.querySelector('main .shopify-section');
	// const productWrapper = document.querySelector('.Product');

	console.log('productBox', productBox);
	const initObserver = new MutationObserver((mutations, observer) => {
		mutations.forEach((mutation) => {
			if (mutation.addedNodes.length) {
				const addedElement = mutation.addedNodes[0];

				// Quit if the added element is not an Element or if it does not contain the price element
				if (!(addedElement instanceof Element)) return;
				if (addedElement.id !== 'rbr-container-element-false') return;

				console.log('addedElement', addedElement.id);

				// Move element to .Product__Gallery
				firstSection.insertAdjacentElement('afterend', addedElement);
				addedElement.classList.add('eg-bundles-list');
				console.log('addedElement', addedElement);
				// productWrapper.appendChild(addedElement);

				setTimeout(() => {
					console.log('productData', productData);

					// Get all bundle product names
					const bundleProducts = addedElement.querySelectorAll(
						'.rbr-stn__productDetail__container',
					);
					bundleProducts.forEach((bundleProduct) => {
						const productName = bundleProduct.querySelector(
							'.rbr-productNamePrice__title__container a',
						).innerText;
						// console.log('productName', productName);

						const textContainer = bundleProduct.querySelector(
							'.rbr-productNamePrice__container',
						);
						// console.log('textContainer', textContainer);

						if (productName === productData.product.title) {
							const badge = document.createElement('span');
							badge.classList.add('Badge');
							badge.innerText = 'Dieses Produkt';
							textContainer.appendChild(badge);

							// insert custom html
							textContainer;
						}
					});
				}, 1000);

				// NOTE - Stop observing
				observer.disconnect();
			}
		});
	});

	initObserver.observe(productBox, {
		childList: true,
		subtree: true,
	});
});
